import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Nav from '../../shared-components/navbar/Nav';

class NavContainer extends Component {
  render () {
    return <Nav {...this.props} />;
  }
}

NavContainer.propTypes = {
  auth: PropTypes.object.isRequired
};

function mapStateToProps (state) {
  const { auth, nav, profile, entitlements, nux } = state;
  const { accessToken } = auth;
  const { SSOid } = profile;

  return {
    auth,
    nav,
    profile,
    SSOid,
    accessToken,
    entitlements,
    nux
  };
}

export default connect(mapStateToProps)(NavContainer);
